module.exports = __webpack_public_path__ + "static/media/btn-plus-max.7f76e4af.svg";